import type { ComponentWithAs, GridProps, IconProps} from "@chakra-ui/react";
import { Grid, useMediaQuery } from "@chakra-ui/react";
import type { ReactNode } from "react";
import React from "react";
import type { IPropsText} from "../../components/Text";
import { Text} from "../../components/Text";
import type { IPropsTitle} from "../../components/Title";
import { Title} from "../../components/Title";
import { minWidth800BP } from "../../constants";
import { BoxRow } from "../BoxRow";

export interface DisplayInfoCardProps {
	icon?: ReactNode | undefined;
	title?: string;
	displayInfo?: string;
	description?: ReactNode | string;
	hasShadow?: boolean;
	titleProps?: Partial<IPropsText>;
	displayProps?: Partial<IPropsTitle>;
	descriptionProps?: Partial<IPropsText>;
	gridProps?: Partial<GridProps>;
	chip?: ReactNode;
	cards?: [] | [{icon: ComponentWithAs<"svg", IconProps>; description: string},{icon: ComponentWithAs<"svg", IconProps>; description: string},{icon: ComponentWithAs<"svg", IconProps>; description: string}];
}


export const DisplayInfoCard = ({ icon, displayInfo, title, description, hasShadow = false, displayProps, titleProps, descriptionProps, cards, chip, gridProps }: DisplayInfoCardProps) => {
	const [isLargerThan800] = useMediaQuery(minWidth800BP);

	return (
		<Grid
			borderRadius={isLargerThan800 ? 10 : 0}
			padding={isLargerThan800 ? "40px 32px 24px" : "32px 24px"}
			bg={isLargerThan800 ? "transparent" : "white.600"}
			width="100%"
			maxWidth="676px"
			display="flex"
			flexDirection="column"
			alignItems="flex-start"
			boxShadow={hasShadow ? "inset 0px -5px 5px -1px #DDDDDD" : "none"}
			margin='auto'
			{...gridProps}
		>
			{icon && icon }
			<Text preset="preset3" fontWeight="light" line-height="40px" mb="8px" {...titleProps}>{title}</Text>
			<Title preset={isLargerThan800 ? "preset6" : "preset8"} mb="8px" line-height="40px" {...displayProps}>{displayInfo}</Title>
			{chip}
			<Text preset="preset3" fontWeight="regular" line-height="40px" {...descriptionProps}>{description}</Text>
			{cards && cards.length > 0 ?
				<div style={{ paddingTop: isLargerThan800 ? "40px" : "56px", alignSelf: isLargerThan800 ? "center" : "unset", width: isLargerThan800 ? "unset" : "100%", marginBottom: isLargerThan800 ? "-8px" : "unset" }}>
					{cards.map((item: { icon: ComponentWithAs<"svg", IconProps>; description: string }, index: number) => (
						<BoxRow key={index} boxRowProps={{ w: { base: "100%", lg: "416px" }, p: "16px", backgroundColor: "#FFFFFF", margin: "8px 0px" }} icon={item.icon} iconSize={"32px"} description={item.description} textLineHeight={"24px"} textColor={"#000000"} />
					))}
				</div> : null}
		</Grid>
	);
};
